// src/components/SuccessMessage.tsx
import React from "react";
import { CheckCircle2 } from "lucide-react";

interface SuccessMessageProps {
  message: string;
}

const SuccessMessage: React.FC<SuccessMessageProps> = ({ message }) => {
  return (
    <div className="flex items-center gap-2 p-3 rounded-md bg-green-50 text-green-700 border border-green-200">
      <CheckCircle2 size={20} />
      <span>{message}</span>
    </div>
  );
};

export default SuccessMessage;
